import React from "react";
import './Box1.css';

function Box1(probs) {

  return (
    <div className="box1-box3">
      <div className="box1-box6"><img className="box1-box6-picture8" src={probs.ImgBox1} alt="picture8"/></div>
      <div className="box1-box7">{probs.NadpisBox1}</div>
      <div className="box1-box8">{probs.PopisBox1}</div>
    </div>
  );
}

export default Box1;
